var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9687 5.47836C11.8901 5.21512 11.6746 5.02816 11.4196 5.00326L7.95612 4.66256L6.58655 1.18977C6.48556 0.935255 6.25558 0.770508 6.00005 0.770508C5.74452 0.770508 5.51453 0.935255 5.41355 1.19036L4.04398 4.66256L0.579907 5.00326C0.325385 5.02875 0.110414 5.21512 0.0314018 5.47836C-0.0476101 5.7416 0.0253592 6.03033 0.217899 6.21234L2.83591 8.69972L2.06392 12.3838C2.00743 12.6547 2.10448 12.9347 2.31194 13.0971C2.42346 13.1844 2.55392 13.2288 2.68549 13.2288C2.79892 13.2288 2.91144 13.1957 3.01243 13.1303L6.00005 11.1958L8.98657 13.1303C9.20511 13.2727 9.4806 13.2597 9.6876 13.0971C9.89516 12.9342 9.99212 12.6541 9.93563 12.3838L9.16364 8.69972L11.7816 6.21283C11.9742 6.03033 12.0477 5.7421 11.9687 5.47836Z",
    fill: "#5DDEA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star2.0e7b518f1ce116dc8e7ae53624911065.svg";
export { ForwardRef as ReactComponent };